import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';

const OrientationOverlay = () => {
    const {t} = useTranslation();

    useEffect(() => {
          function isMobileDevice() {
              return /Android|webOS|iPhone|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini|SM-G955U|Macintosh; Intel Mac OS X 10_15_7/i.test(navigator.userAgent);
          }

          
          function isSmallDesktop() {
            return !isMobileDevice() && (window.innerHeight < 769  && window.innerWidth < 1165) || window.innerHeight < 600
          }
          
          function isHorizontalOnMobile() {
            if (!isMobileDevice()) {
              return false;
            }

            return ((window.innerWidth > window.innerHeight) && (window.innerHeight < 769  && window.innerWidth < 1165)) || ((window.innerWidth > window.innerHeight) && (window.innerHeight < 600))
          }
          
          if (isHorizontalOnMobile() || isSmallDesktop()) {
            document.getElementById('orientation-overlay').classList.add('orientation-overlay');
          } else {
            document.getElementById('orientation-overlay').classList.remove('orientation-overlay');
          }          
          
          window.addEventListener('orientationchange', () => {
            setTimeout(() => {
              if (isHorizontalOnMobile() || isSmallDesktop()) {
                document.getElementById('orientation-overlay').classList.add('orientation-overlay');
              } else {
                document.getElementById('orientation-overlay').classList.remove('orientation-overlay');
              }    
            }, 100);  
          })
          
          window.addEventListener('resize', () => {
            setTimeout(() => {
              if (isHorizontalOnMobile() || isSmallDesktop()) {
                document.getElementById('orientation-overlay').classList.add('orientation-overlay');
              } else {
                document.getElementById('orientation-overlay').classList.remove('orientation-overlay');
              }    
            }, 100);  
          })
      },[]);

    return (
            <div id="orientation-overlay">
                <p>{t('orientation-overlay')}</p>
            </div>
    )
}

export default OrientationOverlay;